import axios from './axios.js'

export const verifyTokenRequest = () => axios.get('/verify')

export const logoutRequest = () => axios.post('/logout')